export type PreviewPage = {
  src: string;
  alt: string;
};

export const previewPages: PreviewPage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/ew7fwVX593Wt33UNHLYaRU/PAGINA_1_MINIERA.jpg',
    alt: "Pagina di esempio I metalli di base muovono l'industria",
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/4ei9z93UYNZ91bGW6oX7WU/PAGINA_2_MINIERA.jpg',
    alt: 'Pagina di esempio Uno smartphone è una piccola miniera',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/4GBh4QgikqnwWaxsQ3Gnza/PAGINA_3_MINIERA.jpg',
    alt: 'Pagina di esempio Il ciclo di vita di una miniera',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/pXnkfDZV1zfAhdNBuzRYY9/PAGINA_4_MINIERA.jpg',
    alt: 'Pagina di esempio Due strade per arrivare al minerale: cielo aperto e sotterraneo',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/gsR8hnGyUpnpvLMAYyqJBK/PAGINA_5_MINIERA.jpg',
    alt: 'Pagina di esempio I materiali della transizione energetica',
  },
];
